module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/40ft-mobile-97e175a5f7962b8c8f911ca4e7f8ebbb.png";